import ClearIcon from '@/icons/16/x-circle.svg'
import SearchIcon from '@/icons/24/magnifying-glass.svg'
import Input, { InputProps } from './Input'

export interface SearchInputProps extends Omit<InputProps, 'start' | 'end'> {
  onClearClick?: () => void
}

export default function SearchInput({
  onClearClick,
  ...props
}: SearchInputProps) {
  return (
    <Input
      {...props}
      start={<SearchIcon className="text-quaternary" />}
      end={
        props.value &&
        onClearClick && (
          <button
            className="size-8 -mr-2"
            tabIndex={-1}
            onClick={() => {
              onClearClick()
            }}
          >
            <ClearIcon className="text-quaternary m-auto" />
          </button>
        )
      }
    />
  )
}
